(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _j_accordion = require('./../libs/j_accordion');

var _j_accordion2 = _interopRequireDefault(_j_accordion);

var _j_ua = require('./../libs/j_ua');

var _j_ua2 = _interopRequireDefault(_j_ua);

var _j_smoothScroll = require('./../libs/j_smoothScroll');

var _j_smoothScroll2 = _interopRequireDefault(_j_smoothScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Init = function Init() {

    // accordion
    var J_ACCORDION = new _j_accordion2.default(".j-accordion", {
        toggleSpeed: 400
    });

    // User Agent
    var UA = new _j_ua2.default();

    if (UA.isSp) {

        // if ( UA.isIphone ) {
        //   document.body.classList.add('iphone');
        // } else if ( UA.isAndroid ) {
        //   document.body.classList.add('android_sp');
        // } else {
        //   document.body.classList.add('other_sp');
        // }

        document.getElementById('ToCvBtn').textContent = '今すぐ申し込む';
    } else {

        document.body.classList.add('pc_tab');
    };

    // /////////////////////////////
    // ナビゲーション
    // //////////////////////////////
    var isSmoothScrolling = false;
    var isFixBtn = false;

    var SECTION = [].slice.call(document.querySelectorAll('.f-section'), 0);
    var NAVIBUTTON = [].slice.call(document.querySelectorAll('#nav li a'), 0);
    var ANCHOR = [].slice.call(document.querySelectorAll('a[href^="#"],area[href^="#"]'), 0);
    var FIX_BTN = document.getElementById('fixBtn');

    // smooth scroll
    var J_SCROLL = new _j_smoothScroll2.default("a.ss", {
        easing: "easeOutQuint",
        ignore: ".ignore",
        posFix: -1,
        blank: true
    });
    J_SCROLL.CarryingHash = function (hash) {

        isSmoothScrolling = true;

        var TARGET = '#' + hash;

        NAVIBUTTON.forEach(function (v, i) {

            v.classList.remove('current');

            if (v.hash === TARGET) {
                v.classList.add('current');
            }
        });
    };
    J_SCROLL.ScrollEnd = function () {

        isSmoothScrolling = false;
    };

    var GetCurrentPosition = function GetCurrentPosition() {

        var SCROLL_TOP = document.documentElement.scrollTop || document.body.scrollTop;
        var WINDOW_HEIGHT = window.innerHeight;
        var SCROLL_BOTTOM = SCROLL_TOP + WINDOW_HEIGHT;

        var EACH_HEIGHTS = SECTION.map(function (v) {
            return v.getBoundingClientRect().top + window.pageYOffset;
        });

        EACH_HEIGHTS.forEach(function (v, i, a) {

            if (SCROLL_TOP >= a[i] && !isSmoothScrolling) {

                NAVIBUTTON.forEach(function (w) {
                    w.classList.remove('current');
                });
                NAVIBUTTON[i].classList.add('current');
            }
        });

        if (SCROLL_BOTTOM >= EACH_HEIGHTS[2] && SCROLL_BOTTOM <= EACH_HEIGHTS[7]) {
            if (!isFixBtn) {
                isFixBtn = true;
            }
        } else {
            if (isFixBtn) {
                isFixBtn = false;
            }
        }

        if (!isFixBtn) {
            FIX_BTN.classList.remove('active');
        } else {
            FIX_BTN.classList.add('active');
        }
    };

    window.addEventListener('load', function () {
        GetCurrentPosition();
    });
    window.addEventListener('resize', function () {
        GetCurrentPosition();
    });
    window.addEventListener('scroll', function () {
        GetCurrentPosition();
    });
};

exports.default = Init;

},{"./../libs/j_accordion":2,"./../libs/j_smoothScroll":3,"./../libs/j_ua":4}],2:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*

MeganeTemplate

Version: 5.0.0
Website: http://megane-template.com/
License: Dentsu Isobar All Rights Reserved.

*/

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
        module.exports = factory();
    } else {
        root.jAccordion = factory();
    }
})(undefined, function () {

    function jAccordion(selector, option) {

        this.selector = selector;
        this.accordion = document.querySelectorAll(this.selector);

        //option
        if (option == null) option = {};
        this.toggleSpeed = option.toggleSpeed ? option.toggleSpeed : 1;
        this.btnElm = option.btnElm ? option.btnElm : ".j-accordion_btn";
        this.detailElm = option.detailElm ? option.detailElm : ".j-accordion_detail";

        this.OpenEnd = function () {};
        this.CloseEnd = function () {};

        this.clickFlag = false;

        if (this.accordion.length != 0) {
            this.Init();
        };
    }

    jAccordion.prototype.AddTransition = function (target) {
        target.style.transition = "max-height " + this.toggleSpeed / 1000 + "s";
        target.style.setProperty('-webkit-transition', "max-height " + this.toggleSpeed / 1000 + "s");
    };
    jAccordion.prototype.RemoveTransition = function (target) {
        target.style.transition = "none";
        target.style.setProperty('-webkit-transition', "none");
    };

    /**
    **
    ** Init
    **
    **/
    jAccordion.prototype.Init = function () {
        var this_ = this;

        var initCss = "overflow: hidden;";
        initCss += "transition: max-height " + this.toggleSpeed / 1000 + "s ;";
        initCss += "-webkit-transition: max-height " + this.toggleSpeed / 1000 + "s ;";

        for (var i = 0; i < this.accordion.length; i++) {

            var DETAIL = this.accordion[i].querySelectorAll(this.detailElm);
            var BTN = this.accordion[i].querySelectorAll(this.btnElm);

            for (var j = 0; j < BTN.length; j++) {

                if (DETAIL[j]) {
                    DETAIL[j].style.cssText = initCss;
                    if (!this.HasClass(DETAIL[j], "active")) {
                        DETAIL[j].style.maxHeight = "0px";
                    }
                }

                BTN[j].addEventListener("click", function (e) {

                    e.preventDefault();

                    this_.Toggle(e);
                });
            }
        }
    };

    /**
    **
    ** Toggle
    **
    **/
    jAccordion.prototype.Toggle = function (element) {

        if (!this.accordion[0]) {
            console.error(this.selector + ": Not Found");
            return false;
        }

        var TARGET = element.currentTarget ? element.currentTarget : document.querySelectorAll(element)[0];

        if (this.HasClass(TARGET, "active")) {

            if (!this.clickFlag) this.Close(element);
        } else {

            if (!this.clickFlag) this.Open(element);
        }
    };

    /**
    **
    ** Open, Close
    **
    **/
    jAccordion.prototype.Open = function (element) {

        var this_ = this;

        if (!this.accordion[0]) {
            console.error(this.selector + ": Not Found");
            return false;
        }

        this.clickFlag = true;

        var TARGET = element.currentTarget ? element.currentTarget : document.querySelectorAll(element)[0];
        var PARENT = this.GetParent(TARGET, this.selector);

        var INDEX = Array.prototype.indexOf.call(PARENT.querySelectorAll(this.btnElm), TARGET);

        var TARGET_DETAIL = PARENT.querySelectorAll(this.detailElm)[INDEX];

        // TARGET_DETAIL.style.display = "block";
        TARGET_DETAIL.style.maxHeight = TARGET_DETAIL.scrollHeight + "px";

        var EndFunc = function EndFunc() {
            this_.clickFlag = false;
            this_.OpenEnd(INDEX);
            this_.RemoveTransition(TARGET_DETAIL);
            TARGET_DETAIL.style.maxHeight = null;
            TARGET_DETAIL.removeEventListener("transitionend", EndFunc);
        };

        this.AddClass(TARGET, "active");
        this.AddClass(TARGET_DETAIL, "active");

        if (!this.accordion[0].classList) {
            this.clickFlag = false;
        } else {
            TARGET_DETAIL.addEventListener("transitionend", EndFunc, false);
        }
    };

    jAccordion.prototype.Close = function (element) {

        var this_ = this;

        if (!this.accordion[0]) {
            console.error(this.selector + ": Not Found");
            return false;
        }

        this.clickFlag = true;

        var TARGET = element.currentTarget ? element.currentTarget : document.querySelectorAll(element)[0];
        var PARENT = this.GetParent(TARGET, this.selector);

        var INDEX = Array.prototype.indexOf.call(PARENT.querySelectorAll(this.btnElm), TARGET);

        var TARGET_DETAIL = PARENT.querySelectorAll(this.detailElm)[INDEX];
        var EndFunc = function EndFunc() {
            this_.clickFlag = false;
            this_.CloseEnd(INDEX);
            TARGET.style.pointerEvents = "inherit";
            // TARGET_DETAIL.style.display = "none";
            TARGET_DETAIL.removeEventListener("transitionend", EndFunc);
        };

        //

        this.RemoveClass(TARGET, "active");
        this.RemoveClass(TARGET_DETAIL, "active");

        TARGET_DETAIL.style.maxHeight = TARGET_DETAIL.scrollHeight + "px";
        setTimeout(function () {
            this_.AddTransition(TARGET_DETAIL);
            TARGET_DETAIL.style.maxHeight = "0px";
        }, 10);

        if (!this.accordion[0].classList) {
            //IE9

            // TARGET_DETAIL.style.display = "none";
            this.clickFlag = false;
        } else {

            TARGET_DETAIL.addEventListener("transitionend", EndFunc, false);
        }
    };

    jAccordion.prototype.CloseIgnoreThis = function (element) {

        if (!this.accordion[0]) {
            console.error(this.selector + ": Not Found");
            return false;
        }

        var TARGET = element;
        var PARENT = this.GetParent(TARGET, this.selector);

        var INDEX = Array.prototype.indexOf.call(PARENT.querySelectorAll(this.btnElm), TARGET);

        var TARGET_BTN = PARENT.querySelectorAll(this.btnElm);
        var TARGET_DETAIL = PARENT.querySelectorAll(this.detailElm);

        for (var i = 0; i < TARGET_BTN.length; i++) {

            if (i != INDEX) {
                TARGET_BTN[i].classList.remove("active");
                Close_(i);
            }
        }

        //

        function Close_(i) {

            TARGET_DETAIL[i].classList.remove("active");

            setTimeout(function () {
                TARGET_DETAIL[i].style.maxHeight = "0px";
            }, 100);
        }
    };

    /**
    **
    ** GetParent
    **
    **/
    jAccordion.prototype.GetParent = function (element, target) {

        var parent = element,
            i = 0,
            t;

        if (target.split(".")[1]) {

            t = target.split(".")[1];
        } else if (target.split("#")[1]) {

            t = target.split("#")[1];
        } else {

            t = target;
        }

        while (i < 100) {

            parent = parent.parentNode;

            if (parent.tagName.toLowerCase() == t) break;

            if (parent.className) {
                if (parent.className.match(t)) break;
            } else if (parent.id) {
                if (parent.id.match(t)) break;
            }

            i++;
        }

        return parent;
    };

    jAccordion.prototype.AddClass = function (element, _className) {

        if (element.classList) {
            element.classList.add(_className);
        } else {
            element.className += ' ' + _className;
        }
    };
    jAccordion.prototype.RemoveClass = function (element, _className) {

        if (element.classList) {
            element.classList.remove(_className);
        } else {
            element.className = element.className.replace(new RegExp('(^|\\b)' + _className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };
    jAccordion.prototype.HasClass = function (element, _className) {

        var ignore = false;

        if (element.classList) {
            if (element.classList.contains(_className)) ignore = true;
        } else {
            if (new RegExp('(^| )' + _className + '( |$)', 'gi').test(element.className)) ignore = true;
        }

        return ignore;
    };

    return jAccordion;
});

},{}],3:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*

MeganeTemplate

Version: 5.0.0
Website: http://megane-template.com/
License: Dentsu Isobar All Rights Reserved.

*/

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
        module.exports = factory();
    } else {
        root.jSmoothScroll = factory();
    }
})(undefined, function () {

    function jSmoothScroll(selector, option) {

        this.selector = selector;
        this.btn = document.querySelectorAll(this.selector);

        //option
        if (option == null) option = {};
        this.speed = option.speed ? option.speed : 800;
        this.easing = option.easing ? option.easing : "linear";
        this.posFix = option.posFix ? option.posFix : 0;
        this.ignore = option.ignore ? option.ignore : "";
        this.blank = option.blank ? option.blank : false;
        this.customAnchor = option.customAnchor ? option.customAnchor : "#/";

        this.moveFlag = false;

        this.ScrollStart = function () {};
        this.CarryingHash = function (hash) {};
        this.ScrollEnd = function () {};

        var this_ = this;

        if (this.btn[0]) {
            this.oldBrowser = this.GetAndroidVersion() < 4.4 || !this.btn[0].classList;
            this.Init();
        }

        if (this.blank) {
            window.addEventListener("load", function () {
                setTimeout(function () {
                    this_.AnchorLink();
                }, 200);
            });
        }
    }

    /**
    **
    ** Init
    **
    **/
    jSmoothScroll.prototype.Init = function () {

        var this_ = this;

        for (var i = 0; i < this.btn.length; i++) {

            this.btn[i].addEventListener("click", function (e) {

                var ignore = false;
                var IGUNORE_TXT = this_.ignore.split(",");

                for (var j = 0; j < IGUNORE_TXT.length; j++) {
                    //not処理

                    var IGUNORE = IGUNORE_TXT[j].split(".")[1] ? IGUNORE_TXT[j].split(".")[1] : IGUNORE_TXT[j].split("#")[1];

                    if (e.currentTarget.classList) {
                        if (e.currentTarget.classList.contains(IGUNORE)) ignore = true;
                    } else {
                        if (new RegExp('(^| )' + IGUNORE + '( |$)', 'gi').test(e.currentTarget.className)) ignore = true;
                    }
                    if (e.currentTarget.id == IGUNORE) ignore = true;
                }

                if (!this_.moveFlag) {
                    //ダブルクリック防止

                    var GET_HASH = e.currentTarget.getAttribute("href");

                    if (GET_HASH && GET_HASH.split("#")[0] == "" && !ignore) {

                        e.preventDefault();
                        this_.moveFlag = true;
                        this_.ScrollStart();

                        var HASH = GET_HASH.split("#")[1];

                        this_.CarryingHash(HASH);

                        var TARGET = document.getElementById(HASH);
                        var OFFSET_TOP = this_.GetOffset(TARGET).top;

                        this_.SmoothScroll(OFFSET_TOP);
                    }
                }
            });
        }
    };

    /**
    **
    ** SmoothScroll
    **
    **/
    jSmoothScroll.prototype.SmoothScroll = function (p) {

        var this_ = this;

        var POSITION = p - this.posFix;

        var SCROLL_VAL = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;

        var DIFF = POSITION - SCROLL_VAL;
        var num = SCROLL_VAL;

        var START_TIME = new Date().getTime(); //描画開始時刻を取得
        var render;
        var numPrev = SCROLL_VAL;

        var Loop;

        var LoopAnim = function LoopAnim() {

            if (!this_.oldBrowser) render = requestAnimationFrame(Loop);

            var CURRENT_TIME = new Date().getTime(); //経過時刻を取得
            var STATUS = CURRENT_TIME - START_TIME; // 描画開始時刻から経過時刻を引く

            var MOVE_Y = Math.round(Easing[this_.easing](STATUS, SCROLL_VAL, Math.abs(DIFF), this_.speed));

            if (DIFF > 0) {
                num += MOVE_Y - numPrev;
            } else {
                num += -(MOVE_Y - numPrev);
            }

            window.scroll(0, num);

            numPrev = MOVE_Y;

            if (STATUS >= this_.speed) {

                this_.moveFlag = false;
                this_.ScrollEnd();

                if (this_.oldBrowser) {
                    clearInterval(Loop);
                } else {
                    cancelAnimationFrame(render);
                }

                window.scroll(0, POSITION);
            }
        };

        if (this.oldBrowser) {
            Loop = setInterval(LoopAnim, 33); // Android4.4未満は setInterval で処理
        } else {
            Loop = LoopAnim;
            Loop();
        }
    };

    /**
    **
    ** GetOffset
    **
    **/
    jSmoothScroll.prototype.GetOffset = function (el) {

        var BOX = el.getBoundingClientRect();

        return {
            top: BOX.top + window.pageYOffset - document.documentElement.clientTop,
            left: BOX.left + window.pageXOffset - document.documentElement.clientLeft
        };
    };

    /**
    **
    ** AnchorLink
    **
    **/
    jSmoothScroll.prototype.AnchorLink = function () {

        for (var i = 0; i < this.btn.length; i++) {

            var ignore = false;
            var IGUNORE_TXT = this.ignore.split(",");
            var GET_HASH = this.btn[i].getAttribute("href");

            for (var j = 0; j < IGUNORE_TXT.length; j++) {
                //not処理

                var IGUNORE = IGUNORE_TXT[j].split(".")[1] ? IGUNORE_TXT[j].split(".")[1] : IGUNORE_TXT[j].split("#")[1];

                if (this.btn[i].classList) {
                    if (this.btn[i].classList.contains(IGUNORE)) ignore = true;
                } else {
                    if (new RegExp('(^| )' + IGUNORE + '( |$)', 'gi').test(this.btn[i].className)) ignore = true;
                }
                if (this.btn[i].id.match(IGUNORE)) ignore = true;
            }

            if (GET_HASH && !ignore) {

                var HREF_SPLIT = GET_HASH.split("#");

                if (HREF_SPLIT.length > 1 && HREF_SPLIT[0] != "") {

                    this.btn[i].setAttribute("href", GET_HASH.replace(/#/g, this.customAnchor));
                }
            }
        }

        if (location.href.split(this.customAnchor)[1]) {

            var TARGET = document.getElementById(location.href.split(this.customAnchor)[1]);
            var OFFSET_TOP = this.GetOffset(TARGET).top;
            this.SmoothScroll(OFFSET_TOP);
        }
    };

    jSmoothScroll.prototype.GetAndroidVersion = function () {

        var ua = navigator.userAgent;

        if (ua.toLowerCase().indexOf('android') > 0 && ua.toLowerCase().indexOf('mobile') > 0) {
            return parseFloat(ua.slice(ua.indexOf("Android") + 8));
        }
    };

    /**
    **
    ** Easing
    **
    ** t : 時間(進行度)
    ** b : 開始の値(開始時の座標やスケールなど)
    ** c : 開始と終了の値の差分
    ** d : Tween(トゥイーン)の合計時間
    **
    **/
    var Easing = {

        "linear": function linear(t, b, c, d) {
            t /= d;
            return c * t + b;
        },

        //Cubic
        "easeInCubic": function easeInCubic(t, b, c, d) {
            t /= d;
            return c * t * t * t + b;
        },
        "easeOutCubic": function easeOutCubic(t, b, c, d) {
            t /= d;
            t = t - 1;
            return c * (t * t * t + 1) + b;
        },
        "easeInOutCubic": function easeInOutCubic(t, b, c, d) {
            t /= d / 2.0;
            if (t < 1) {
                return c / 2.0 * t * t * t + b;
            } else {
                t = t - 2;
                return c / 2.0 * (t * t * t + 2) + b;
            }
        },

        //Quartic
        "easeInQuart": function easeInQuart(t, b, c, d) {
            t /= d;
            return c * t * t * t * t + b;
        },
        "easeOutQuart": function easeOutQuart(t, b, c, d) {
            t /= d;
            t = t - 1;
            return -c * (t * t * t * t - 1) + b;
        },
        "easeInOutQuart": function easeInOutQuart(t, b, c, d) {
            t /= d / 2.0;
            if (t < 1) {
                return c / 2.0 * t * t * t * t + b;
            } else {
                t = t - 2;
                return -c / 2.0 * (t * t * t * t - 2) + b;
            }
        },

        //Quintic
        "easeInQuint": function easeInQuint(t, b, c, d) {
            t /= d;
            return c * t * t * t * t * t + b;
        },
        "easeOutQuint": function easeOutQuint(t, b, c, d) {
            t /= d;
            t = t - 1;
            return c * (t * t * t * t * t + 1) + b;
        },
        "easeInOutQuint": function easeInOutQuint(t, b, c, d) {
            t /= d / 2.0;
            if (t < 1) {
                return c / 2.0 * t * t * t * t * t + b;
            } else {
                t = t - 2;
                return c / 2.0 * (t * t * t * t * t + 2) + b;
            }
        }

    };

    return jSmoothScroll;
});

},{}],4:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*

MeganeTemplate

Version: 5.0.0
Website: http://megane-template.com/
License: Dentsu Isobar All Rights Reserved.

*/

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
        module.exports = factory();
    } else {
        root.Ua = factory();
    }
})(undefined, function () {

    function Ua() {

        this._ua = navigator.userAgent;
        this._ver = navigator.appVersion;

        var ua = this._ua.toLowerCase();
        var ver = this._ver.toLowerCase();

        // IE(11以外)
        this.isMSIE = ua.indexOf('msie') > -1 && ua.indexOf('opera') == -1;
        // IE6
        this.isIE6 = this.isMSIE && ver.indexOf('msie 6.') > -1;
        // IE7
        this.isIE7 = this.isMSIE && ver.indexOf('msie 7.') > -1;
        // IE8
        this.isIE8 = this.isMSIE && ver.indexOf('msie 8.') > -1;
        // IE9
        this.isIE9 = this.isMSIE && ver.indexOf('msie 9.') > -1;
        // IE10
        this.isIE10 = this.isMSIE && ver.indexOf('msie 10.') > -1;
        // IE11
        this.isIE11 = ua.indexOf('trident/7') > -1;
        // IE
        this.isIE = this.isMSIE || this.isIE11;
        // Edge
        this.isEdge = ua.indexOf('edge') > -1;

        // Google Chrome
        this.isChrome = ua.indexOf('chrome') > -1 && ua.indexOf('edge') == -1;
        // Firefox
        this.isFirefox = ua.indexOf('firefox') > -1;
        // Safari
        this.isSafari = ua.indexOf('safari') > -1 && ua.indexOf('chrome') == -1;
        // Opera
        this.isOpera = ua.indexOf('opera') > -1;

        // iPhone
        this.isIphone = ua.indexOf('iphone') > 0;
        // iPod
        this.isIpod = ua.indexOf('ipod') > 0;
        // Android
        this.isAndroid = ua.indexOf('android') > 0 && ua.indexOf('mobile') > 0;
        // Windows Phone
        this.isWinPhone = ua.indexOf('windows phone') > 0;
        // iPad
        this.isIpad = ua.indexOf('ipad') > 0;
        // Android Tablet (Android 4.1〜)
        this.isAndroidTab = ua.indexOf('android') > 0 && ua.indexOf('mobile') == -1;

        // Sp
        this.isSp = this.isIphone || this.isIpod || this.isAndroid || this.isWinPhone;
        // Tab
        this.isTab = this.isIpad || this.isAndroidTab;
        // Touch Device
        this.isTouch = 'createTouch' in document || 'ontouchstart' in document;
    }

    Ua.prototype.GetIosVersion = function () {

        var v, versions;
        if (this.isIphone || this.isIpod || this.isIpad) {
            v = this._ver.match(/OS (\d+)_(\d+)_?(\d+)?/);
            versions = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
            return Number(versions[0] + "." + versions[1]);
        }
        return versions;
    };

    Ua.prototype.GetAndroidVersion = function () {

        if (this.isAndroid) {
            return Number(parseFloat(this._ua.slice(this._ua.indexOf("Android") + 8)));
        }
    };

    return Ua;
});

},{}],5:[function(require,module,exports){
'use strict';

var _common = require('./common/common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

////

var Init = function Init() {

	(0, _common2.default)();
};

Init();

},{"./common/common":1}]},{},[5])

